import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { Printer } from "lucide-react";
import { api, TIPOS_CITA, ESTADOS_CITA } from "@/lib/api";

const Prof = ({ p, citas }) => (
  <section className="mb-6 break-inside-avoid" data-testid={`imprimir-prof-${p.id}`}>
    <h2 className="mb-1 flex items-center gap-2 border-b-2 border-slate-800 pb-1 text-base font-bold">
      <span className="h-3 w-3 rounded-sm print:border print:border-slate-400" style={{ background: p.color }} />{p.nombre}
      <span className="ml-auto text-xs font-normal text-slate-500">{citas.length} cita{citas.length === 1 ? "" : "s"}</span>
    </h2>
    {citas.length ? (
      <table className="w-full text-sm">
        <tbody>
          {citas.map((a) => (
            <tr key={a.id} className="border-b border-slate-200 align-top">
              <td className="w-24 py-1 font-semibold">{a.inicio}–{a.fin}</td>
              <td className="py-1">{a.patient?.nombre || a.titulo || "—"}{a.patient?.codigo ? <span className="text-slate-500"> · nº {a.patient.codigo}</span> : ""}{a.patient && a.titulo ? <span className="block text-xs text-slate-500">{a.titulo}</span> : ""}</td>
              <td className="w-28 py-1 text-xs">{TIPOS_CITA[a.tipo]?.label}</td>
              <td className="w-28 py-1 text-xs">{a.patient?.telefono || ""}</td>
              <td className="w-40 py-1 text-xs text-slate-500">{[a.tto_info, a.estado && a.estado !== "programada" ? ESTADOS_CITA[a.estado] : ""].filter(Boolean).join(" · ")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    ) : <p className="text-xs text-slate-400">Sin citas</p>}
  </section>
);

export default function AgendaImprimir() {
  const [sp] = useSearchParams();
  const fecha = sp.get("fecha");
  const centro = sp.get("centro") || "";
  const ids = (sp.get("ids") || "").split(",").filter(Boolean);
  const [data, setData] = useState(null);
  useEffect(() => {
    Promise.all([api.get("/profesionales", { params: { centro } }), api.get("/appointments", { params: { desde: fecha, hasta: fecha, centro } })])
      .then(([p, a]) => setData({ profs: p.data.filter((x) => !ids.length || ids.includes(x.id)), appts: a.data.filter((x) => x.estado !== "anulada" && x.tipo !== "bloqueo") }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fecha, centro]);
  if (!data) return <p className="p-8 text-sm text-slate-500">Cargando…</p>;
  const conCitas = data.profs.filter((p) => data.appts.some((a) => a.profesional_id === p.id));
  return (
    <div className="mx-auto max-w-4xl bg-white p-8 print:p-0" data-testid="agenda-imprimir">
      <div className="mb-4 flex items-center gap-3 print:hidden">
        <button type="button" onClick={() => window.print()} data-testid="imprimir-agenda-btn" className="inline-flex items-center gap-2 rounded-md bg-[#1E3A8A] px-4 py-2 text-sm font-medium text-white hover:bg-[#1E40AF]"><Printer className="h-4 w-4" />Imprimir</button>
        <span className="text-xs text-slate-500">Solo salen las profesionales con citas ese día.</span>
      </div>
      <h1 className="mb-5 text-xl font-bold first-letter:uppercase">Agenda · {format(new Date(`${fecha}T12:00`), "EEEE d 'de' MMMM yyyy", { locale: es })}{centro ? ` · ${centro === "MADRID" ? "Madrid" : "Alcobendas"}` : ""}</h1>
      {conCitas.length ? conCitas.map((p) => <Prof key={p.id} p={p} citas={data.appts.filter((a) => a.profesional_id === p.id).sort((x, y) => x.inicio.localeCompare(y.inicio))} />) : <p className="text-sm text-slate-500">No hay citas este día.</p>}
    </div>
  );
}
